// import React from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Form,
//   Button,
  
// } from "react-bootstrap"; 

// export default function OG() {
// //    const [open, setOpen] = useState(0);
  

//   return (
//     <>
//     <div className="bg-light py-5">
    
//            <section className="bg-light">
//                   <Container>
//                     <Row className="g-4 align-items-start">
//                       {/* LEFT CONTENT */}
//                       <Col lg={8}>
//                               <div>
//                                   <h1>Operation Greens from MOFPI</h1>

//                                   <h2>About Operation Greens</h2>
//                                   <p>In the budget speech of the Union budget 2018-19, a new "Operation Greens" program in the style of "Operation Flood" with a disbursement of Rs. 500 crores to support former producer organizations (FPO #), agricultural logistics, processing plants and professional administration was introduced. The ministry has therefore formulated a concept for the comprehensive development of the Tomato, Onion and Potato (TOP) value chain.</p>

//                                   <h2>Objectives:</h2>
//                                   <p>1. Increase in the added value of TOP farmers through targeted interventions to strengthen TOP production clusters and their FPOs and Linking / market connecting with market.</p>
//                                   <p>2. Price stabilization for producers and consumers through proper production planning in TOP clusters and the introduction of dual-use varieties.</p>


//                               </div>
//                         </Col>
//                                 <Col lg={4}>
//                                              <div className="p-4 shadow rounded right-form">
//                                                <Form>
//                                                  <Form.Control className="mb-3" placeholder="Name" />
//                                                  <Form.Control className="mb-3" placeholder="Email" />
//                                                  <Form.Control className="mb-3" placeholder="Phone" />
//                                                  <Form.Control className="mb-3" placeholder="Subject" />
//                                                  <Button className="w-100">Get Started</Button>
//                                                </Form>
//                                              </div>
//                                </Col>
//             </Row>                      
//                       <Row className="g-4 align-items-start">
//                           <Col lg={12} xl={12}>
//                               <div>
//                                   <p>3. Post-harvest losses through the development of infrastructure on the farm, development of adequate agricultural logistics, creation of sufficient storage capacities to connect consumer centers,</p>
//                                   <p>4. Increase in food processing capacity and added value in the TOP value chain with a fixed connection to production clusters.</p>
//                                   <p>5. development of a market research network to collect and collect real-time data on demand and supply and price of TOP plants.</p>


//                                   <h2>Strategies:</h2>
//                                   <p>The scheme will have a two-stage strategy: measures to stabilize prices (short term) and projects to develop integrated value chains (long term).</p>
//                                   <p>Short term measures to stabilize measures.</p>
//                                   <p>(I) NAFED will be the Nodal Agency to implement price stabilization measures.</p>
//                                   <p>MoFPI will provide 50% of the subsidy on the following 2 components:</p>
//                                   <p>1. Transport of tomato, onion, and potato plants (TOP) from production to storage,</p>
//                                   <p>2. Procurement of suitable storage facilities for TOP crops;</p>

//                                   <h2>Market Intelligence and Early Warning System</h2>
//                                   <p>MIEWS Dashboard and Portal is a platform for monitoring tomato, onion and potato prices (TOP) and generating intervention warnings according to the terms of the Green Operation program. The portal would disseminate all relevant information on TOP cultures, such as: in a user-friendly visual format. (Click here)</p>
//                                   <p>Long Term Integrated value chain development projects</p>
//                                   <p>Formation and Capacity Building of FPOs</p>
//                                   <p>1. Quality Production</p>
//                                   <p>2. Post-harvest processing facilities - At Farm Level</p>
//                                   <p>3. Post-harvest processing facilities - At Main Processing Site</p>
//                                   <p>4. Agri-Logistics</p>
//                                   <p>5. Marketing/Consumption Points</p>
//                                   <p>Proposals for seeking assistance under the scheme are invited . To view notice inviting proposals (Click Here).The applicant fulfilling the eligibility criteria under the scheme is required to submit the online application on SAMPADA portal of the ministry (Click Here).</p>
                             
//                              <h2>Project components</h2>
//                              <p>I. Price Stabilisation Measures</p>
//                              <p>i. MoFPI will provide 50% of the subsidy through NAFED to empaneled agencies for evacuation of TOP crops from production surplus areas when price falls below three-years average market price at the time of harvest, for the following two components:</p>
//                              <p>(a) Transportation of TOP Crops from production to storage;</p>
//                              <p>(b) Hiring of appropriate storage facilities for TOP Crops</p>
//                              <p>II. Integrated Value Chain Development Projects</p>
//                              <p>A. Capacity Building of FPOs & their consortium</p>
//                              <p>i. Formation of New FPOs in the clusters selected for TOP;</p>
//                              <p>ii. Promotional Activities, Training/Workshop of Farmers and FPOs;</p>
//                              <p>iii. Professional Management Support to FPOs & Federation;</p>
//                              <p>B. Quality production</p>
//                              <p>i. Provision for quality inputs such as seeds;</p>
//                              <p>i. Setting up of Nursery and greenhouses;</p>
//                              <p>ii. Setting up of protected cultivation;</p>
//                              <p>iii. Mechanisation of farm practices;</p>
//                              <p>iv. Promote Contract farming;</p>
//                              <p>v. Varietal change based on market;</p>
//                              <p>C. Post-harvest processing facilities</p>
//                              <p>i. Appropriate storage at Farm level;</p>
//                              <p>ii. Collection centre (CC)/Pack house;</p>
//                              <p>iii. Primary processing such as sorting, grading and packaging facilities;</p>
//                              <p>iv. Secondary processing – any mechanised and mobile processing facilities;</p>
//                              <p>v. Appropriate transportation infrastructure;</p>
//                              <p>D. Agri-Logistics</p>
//                              <p>i. Integrated multi-mode appropriate transportation;</p>
//                              <p>ii. Controlled temperature/ Ventilated trucks with or without raking;</p>
//                              <p>iii. Crates, rakes etc;</p>
//                              <p>iv. Medium/large scale storage at regional, state and national level;</p>
//                              <p>E. Marketing / Consumption Points</p>
//                              <p>i. Appropriate storage facilities at aggregation/ market level;</p>
//                              <p>ii. Sorting, grading and packaging facilities;</p>
//                              <p>iii. Setting-up of retail outlets;</p>
//                              <p>iv. Setting-up of marketing yards at the cluster level;</p>
//                              <p>v. Creation of e-market;</p>
//                              <p>Any other components/innovative intervention required to achieve the objective of the scheme for implementation of the project, but not covered above, may also be considered as eligible components by the sanctioning authority based on the merit of the case.</p>
                             
                             
//                                   <h2>Pattern of Assistance</h2>
//                                   <p>I. For Price Stabilisation Measures</p>
//                                   <p>As a subsidy for harvest time, 50% of the transport costs and 50% of the costs for commissioning suitable storage facilities are made available. The storage facilities are contracted for a maximum period of 4 to 6 months. NAFED is the nodal point for the payment of grants under this component to the eligible organization.</p>
//                                   <p>II. For Integrated value chain development projects</p>
//                                   <p>Since the scheme provides for the integrated development of the TOP value chain, it should preferably contain all the components listed above from A to E (paragraph 4.2) in the project for the development of the integrated value chain. Post-harvest processing plants, including secondary processing plants, become mandatory parts of the project for the development of the value chain. For projects in all areas, grants amounting to 50% of the eligible project costs are awarded, with a maximum of Rs. 50 Crore per project., the grant is 70% of the eligible project costs in all areas, with a maximum of Rs. 50 Crore per project.</p>


//                                   <h2>Implementation</h2>
//                                   <p>To Implement the scheme, we have to check the status and PMA for those details contact</p>
//                                   <p>+91 72077 57511 / email us: info@apexconsultants.in</p>
//                                   <p>Status of Projects</p>
//                                   <p>List of Program Management Agency (PMA)</p>

//                                   <h2>Way Forward</h2>
//                                   <ul>
//                                       <li>There is a need to link major consumption centre to major production centre with a minimal number of intermediaries</li>
//                                       <li>Linking the processing industry with organized retailing. On an average, about one-fourth of the produce must be processed. Budget announcement of increasing the allocation for the food processing industry by 100% is a welcome step in this regard.</li>
//                                       <li>By developing forward and backward linkages, the government can ease large price fluctuations, raise farmers’ share in the price paid by the consumer and at the same time, ensure lower prices for the consumers — a win-win situation for all.</li>
//                                   </ul>

//                                   <h2>How We Assist you?</h2>
//                                   <p>Enrich Services will help you to guide the procedure, we assist in getting you the maximum benefit for your business through the quality preparation of documents, representation and coordination with various targeted departments and help you in timely and hassle free availability of incentives and grants</p>
//                              </div>
//                               </Col>
//                           </Row>
//             </Container>
//         </section>
        
//     </div>
//     </>    
//   );
// }

import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import {
  FaCheckCircle,
  FaGlobe,
  FaList,
  FaIndustry,
  FaRocket,
  FaHandsHelping,
  FaExclamationTriangle
} from "react-icons/fa";

export default function OperationGreens() {
  return (
    <div className="bg-light py-5">
      <section className="bg-light">
        <Container>

          {/* TOP */}
          <Row className="g-4">
            <Col lg={12}>
              <h1>
                Operation Greens Scheme
              </h1>

              <p>
                Operation Greens is a Government initiative introduced to strengthen
                the Tomato, Onion, and Potato (TOP) value chain through infrastructure,
                logistics, and price stabilization measures.
              </p>

              <p>
                The scheme aims to reduce price fluctuations, improve farmer income,
                and enhance supply chain efficiency.
              </p>
            </Col>
          </Row>

          {/* OBJECTIVES */}
          <h2 className="section-title">
            <FaGlobe className="icon" /> Key Objectives
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Increase farmer income</li>
            <li><FaCheckCircle /> Stabilize market prices</li>
            <li><FaCheckCircle /> Reduce post-harvest losses</li>
            <li><FaCheckCircle /> Strengthen supply chain</li>
            <li><FaCheckCircle /> Improve processing capacity</li>
          </ul>

          {/* STRATEGY */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Scheme Strategy
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Short-term price stabilization</li>
            <li><FaCheckCircle /> Long-term value chain development</li>
          </ul>

          {/* SHORT TERM */}
          <h2 className="section-title">
            <FaList className="icon" /> Price Stabilization (Short Term)
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> 50% subsidy on transport</li>
            <li><FaCheckCircle /> 50% subsidy on storage</li>
            <li><FaCheckCircle /> Implemented through NAFED</li>
          </ul>

          {/* LONG TERM */}
          <h2 className="section-title">
            <FaIndustry className="icon" /> Long-Term Development
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Formation of FPOs</li>
            <li><FaCheckCircle /> Quality production improvements</li>
            <li><FaCheckCircle /> Processing & storage facilities</li>
            <li><FaCheckCircle /> Agri-logistics development</li>
            <li><FaCheckCircle /> Market linkage & e-markets</li>
          </ul>

          {/* COMPONENTS */}
          <h2 className="section-title">
            <FaList className="icon" /> Project Components
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Farm-level storage & pack houses</li>
            <li><FaCheckCircle /> Sorting, grading & packaging</li>
            <li><FaCheckCircle /> Cold chain & transport</li>
            <li><FaCheckCircle /> Processing facilities</li>
            <li><FaCheckCircle /> Marketing infrastructure</li>
          </ul>

          {/* FINANCIAL */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Financial Assistance
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> 50% subsidy on eligible project cost</li>
            <li><FaCheckCircle /> Up to ₹50 Crores per project</li>
          </ul>

          {/* INSIGHT */}
          <h2 className="section-title">
            <FaExclamationTriangle className="icon" /> Important Insight
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> Strong project planning is essential</li>
            <li><FaCheckCircle /> Bank approval depends on viability</li>
            <li><FaCheckCircle /> Proper documentation is critical</li>
          </ul>

          {/* HELP */}
          <h2 className="section-title">
            <FaHandsHelping className="icon" /> How We Help You
          </h2>

          <p>
            At Apex Consultants, we assist with DPR preparation, documentation,
            application filing, and coordination with authorities to ensure
            smooth approvals and maximum benefits.
          </p>

          {/* WHY */}
          <h2 className="section-title">
            <FaRocket className="icon" /> Why Choose Us
          </h2>

          <ul className="custom-list">
            <li><FaCheckCircle /> End-to-end project support</li>
            <li><FaCheckCircle /> Expert documentation</li>
            <li><FaCheckCircle /> Faster approvals</li>
            <li><FaCheckCircle /> Risk minimization</li>
            <li><FaCheckCircle /> Continuous support</li>
          </ul>

        </Container>
      </section>
    </div>
  );
}